import { cn } from "@newxsystems/shared";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { MegaMenuLink } from "../MegaMenuLink/MegaMenuLink";
import type { IMegaMenuGroupPanelProps } from "./MegaMenuGroupPanel.props";

export const MegaMenuGroupPanel = ({
  groupItems,
  hidden,
  labelledBy,
  panelId,
}: IMegaMenuGroupPanelProps) => (
  <div
    aria-hidden={hidden}
    aria-labelledby={labelledBy}
    className={cn(
      "absolute inset-x-0 top-full z-50 overflow-x-hidden overflow-y-auto border-b border-foreground bg-background shadow-[0_24px_70px_rgba(17,17,17,0.12)] transition-[max-height,opacity,transform] duration-300 ease-out motion-reduce:transition-none",
      hidden
        ? "pointer-events-none max-h-0 -translate-y-2 opacity-0"
        : "max-h-[calc(100vh-5rem)] translate-y-0 opacity-100",
    )}
    data-state={hidden ? "closed" : "open"}
    id={panelId}
    inert={hidden}
    role="region"
  >
    <BlockContainer as="div" disableSpacing parentClass="grid gap-8 py-8 md:grid-cols-2 lg:gap-12">
      {groupItems.map((group, groupIndex) => {
        const headingId = `${panelId}-group-${groupIndex}`;

        return (
          <section aria-labelledby={headingId} key={`${group.header}-${groupIndex}`}>
            <h2 className="mb-3 text-[17px]/[1.35] font-medium" id={headingId}>
              {group.header}
            </h2>
            <ul aria-labelledby={headingId} className="list-none border-t border-foreground">
              {group.links.map((link, linkIndex) => (
                <li className="border-b border-surface-300" key={`${link.href}-${linkIndex}`}>
                  <MegaMenuLink
                    className="block px-3 py-3 text-base/[1.35] md:text-[17px] hover:bg-surface-200 hover:text-electric-blue"
                    link={link}
                  />
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </BlockContainer>
  </div>
);

MegaMenuGroupPanel.displayName = "MegaMenu::MegaMenuGroupPanel";
